import styles from "./PageWrapper.module.scss";

const PageWrapper = ({ children, isLoggedIn }) => {
    return <div className={isLoggedIn ? styles.pageWrapper : styles.logedOutWrapepr}>{children}</div>;
};

export default PageWrapper;
